module.exports = __webpack_public_path__ + "static/img/produto_g.4005123.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/limao-zero/produto_g.png
// module id = 8aW5
// module chunks = 0